import axios from "axios";
import $day from "dayjs"
const module = {
  namespaced: true,
  state: {
    children: {
      user_children: '',
    },
  },
  mutations: {
    setChildren: (state, info) => {
      info.user_children.filter((item) => {
        item.editableFlag = true
        return item
      })
      state.children = info
    },
    addChild: (state, info) => {
      info.user_children.editableFlag = true
      state.children.user_children.push(info.user_children)
    },
    updateChild: (state, info) => {
      return state.data.user_children = state.data.user_children.filter((item) => {
        if (item.id == info.user_children.id) {
          item = info
        }
        return item
      })
    },
    removeChild: (state, info) => {
      return state.children.user_children = state.children.user_children.filter((item) => {
        return item.id != info
      })
    },
  },
  actions: {
    async fetchChildren ({commit}) {
      const response = await axios.get('user/data/children')
      commit ('setChildren', response.data)
    },
    async updateChild ({commit}, data) {
      data.birth_date = $day(data.birth_date).format('YYYY-MM-DD HH:mm:ss')
      const response = await axios.put('user/data/children/'+data.id, data)
      commit ('updateInfo', response.data)
    },
    async addUserChild ({commit}, data) {
      data.birth_date = $day(data.birth_date).format('YYYY-MM-DD HH:mm:ss')
      const response = await axios.post('user/data/children', data)
      commit ('addChild', response.data)
    },
    async removeChild ({commit}, id) {
      await axios.delete('user/data/children/'+id).then(() => {
        commit ('removeChild', id)
      })
    },
  }
}
export default module
